const facultyInitialState = {
    dialogTitle: '',
    classesOpenDialog: false,
    classesClassID: null,
    classesClassroom: {
        name: '',
        section: '',
        subject: '',
        room: ''
    }
}

export default facultyInitialState;